export const filtersEmpty = filters => {
  return (
    !filters.freetext && !filters.districts.length && !filters.categories.length
  );
};

export const ensureArray = value => {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
};

export const extractDistrict = areaOrDistrict =>
  !areaOrDistrict
    ? null
    : String(areaOrDistrict).length === 1
    ? areaOrDistrict
    : parseInt(String(areaOrDistrict)[0], 10);

export const isDistrictAdmin = (user, areaOrDistrict) =>
  (user.is_district_admin || []).includes(extractDistrict(areaOrDistrict));



/** WEBPACK FOOTER **
 ** ./src/utils/objects.js
 **/